import type { IAccessToken } from '@/modules/auth/types/IAccessToken'
import { useAuthStore } from '@/modules/auth/stores/authStore'

/**
 * Добавляет к любому запросу поле accessToken из Pinia store
 * @param request - исходный объект запроса без поля accessToken
 * @returns объект запроса с добавленным полем accessToken
 */
export const grpcReq = <T extends Omit<object, 'accessToken'>>(request: T): T & IAccessToken => {
  const authStore = useAuthStore()
  const accessToken = authStore.accessToken // получаем токен из Pinia store

  return {
    ...request, // копируем все поля оригинального запроса
    accessToken, // добавляем поле accessToken
  }
}
